/**
 * Shopify Customer Privacy cookie banner:
 * - Replace default copy with approved TH text
 * - Keep privacy policy link (JP-style inline link)
 */
(function () {
  var BODY_TEXT =
    'เราใช้คุกกี้เพื่อปรับปรุงการใช้งาน วิเคราะห์ข้อมูล และแสดงโฆษณาที่เกี่ยวข้อง ดูรายละเอียดเพิ่มเติมได้ที่ ';
  var POLICY_LABEL = 'นโยบายความเป็นส่วนตัว';
  var POLICY_HREF = '/pages/shokz-privacy-policy';

  function applyCopy(banner) {
    if (!banner || banner.getAttribute('data-th-cookie-copy') === '1') return;

    var title = banner.querySelector('#shopify-pc__banner__body-title');
    if (title) title.hidden = true;

    var paragraph = banner.querySelector('.shopify-pc__banner__body p');
    if (!paragraph) return;

    var policyLink =
      paragraph.querySelector('#shopify-pc__banner__body-policy-link') ||
      paragraph.querySelector('a');

    while (paragraph.firstChild) {
      paragraph.removeChild(paragraph.firstChild);
    }

    paragraph.appendChild(document.createTextNode(BODY_TEXT));

    if (policyLink) {
      policyLink.textContent = POLICY_LABEL;
      if (POLICY_HREF) policyLink.setAttribute('href', POLICY_HREF);
      paragraph.appendChild(policyLink);
    } else {
      var link = document.createElement('a');
      link.id = 'shopify-pc__banner__body-policy-link';
      link.href = POLICY_HREF;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = POLICY_LABEL;
      paragraph.appendChild(link);
    }

    banner.setAttribute('data-th-cookie-copy', '1');
  }

  function tryApply() {
    applyCopy(document.getElementById('shopify-pc__banner'));
  }

  tryApply();

  var observer = new MutationObserver(function () {
    tryApply();
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', tryApply);
})();
